export default {
  auto: ['actions'],

  store: {
    state: {
      // TODO: use i18n
      weightOptions: [
        'Very low',
        'Low',
        'Medium',
        'High',
        'Very high',
      ].map((label, index) => ({
        label,
        value: index,
      })),
    },

    getters: {
      weightOptions: state => state.weightOptions,
    },
  },
}
